// a signed-out deep link into a (user) route (an email notification opened in a browser, or before the
// universal link handoff) gets bounced to sign-in. this holds the route the user actually wanted, so
// UserRedirectScreen can finish the trip once they authenticate instead of dumping them on /search.
let pendingRoute: string | null = null

export const setPendingRoute = (route: string) => {
  pendingRoute = route
}

export const consumePendingRoute = () => {
  const route = pendingRoute

  pendingRoute = null

  return route
}
